import DynamicMenu from './common/DynamicMenu'
import EmptyData from './common/EmptyData'
import FilterArea from './common/FilterArea'
import PagePop from './common/PagePop'
import FormPlus from './common/FormPlus'
import Table from './common/Table' 

export default (Vue)=>{
  Vue.component("dynamic-menu", DynamicMenu)
  Vue.component("empty-data", EmptyData)
  Vue.component("filter-area", FilterArea)
  Vue.component("page-pop", PagePop)
  Vue.component("form-plus", FormPlus)
  Vue.component("sn-table", Table) 
}